import React, { useCallback, useEffect, useState } from 'react';
import RecruiterDashboardHeader from '../Components/RecruiterDashboardHeader';
import RecruiterDashboardComponent from '../Components/RecruiterDashboardComponent';
import { getRecruiterDashboard } from '../Services/RecruiterDashboardService';
import { RecruiterDashboardResponse } from '../Types/RecruiterDashboardType';

function RecruiterDashboardPage() {

      const [data, setData] = useState<RecruiterDashboardResponse | null>(null);
      const [loading, setLoading] = useState(true);

      const fetchDashboard = useCallback(async () => {
        setLoading(true);
        try {
          const response = await getRecruiterDashboard();
          if (response.success && response.data) {
            setData(response.data);
          }
        } catch (err) {
          console.error('Failed to load recruiter dashboard', err);
        } finally {
          setLoading(false);
        }
      }, []);

      useEffect(() => {
        fetchDashboard();
      }, [fetchDashboard]);

  return (
    <div>
      <RecruiterDashboardHeader />

      <RecruiterDashboardComponent
        data={data}
        loading={loading}
        onRefresh={fetchDashboard}
      />
    </div>
  );
}

export default RecruiterDashboardPage;